import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { InputValidation } from "../../../helpers/inputValidation";
import { FormatParameter, IFormatParameter } from "@models";
import { clone, cloneDeep, tap } from "lodash";
import { Notification } from '../../../helpers/Notification';

@Component
export default class FormatParametersFormTypeBase extends Vue {
    name = "format-parameters-form-type-base";
    input = InputValidation;
    notification = new Notification();

    @Prop({
        type: Object as () => IFormatParameter
    })
    value: IFormatParameter;


    @Prop({ type: String, default: "" })
    previewPath: string;

    @Prop({
        type: Object as any,
        required: false,
        default: null
    })
    initialValue;

    get local(): IFormatParameter {
        return this.value
            ? this.value
            : new FormatParameter({
                id: null,
                tag: "N/A",
                description: "N/A",
                value: null,
                file: null,
                formatVersionId: null,
                formatVersion: null,
                formatParameterType: null,
                isReplaceableValue: true
            });
    }

    updateValue(key, value) {
        this.$emit(
            "input",
            tap(cloneDeep(this.local), v => (v[key] = value))
        );
    }

    update(callback: (v: IFormatParameter) => void = v => { }): void {
        this.$emit(
            "input",
            tap(cloneDeep(this.local), v => callback(v))
        );
    }

    reset(callback: (v: IFormatParameter) => void = v => { }): void {
        this.$emit(
            "input",
            tap(cloneDeep(this.initialValue), v => callback(v))
        );
    }

    
}
